import React, { useState } from 'react';
import PropTypes from 'prop-types';

import t from '../../../lib/I18n';
import { GlobalModals } from '../../../constants/AppConstants';
import ModalActions from '../../../actions/ModalActions';
import BaseModal from '../../general/BaseModal';
import ValidatedFormField from '../../form/ValidatedField';
import validators from '../../../validation';

const EmailConfirmationModal = ({ onConfirm }) => {
    const [email, setEmail] = useState('');

    const trimmed = email.trim();
    const isValid = !validators.email().validate(trimmed).error;

    const handleFieldChange = (field, value) => {
        setEmail(value);
    };

    const close = () => {
        ModalActions.close(GlobalModals.CONFIRM_EMAIL);
    };

    const handleContinue = () => {
        if (!isValid) {
            return;
        }
        close();
        onConfirm(trimmed);
    };

    return (
        <BaseModal
            className="modal--sm"
            titleText="payment.emailConfirmation.title"
            closeText="button.text.close"
            continueText="button.text.done"
            disableContinue={!isValid}
            onClose={close}
            onContinue={handleContinue}
        >
            <p>{t('payment.emailConfirmation.description')}</p>
            <ValidatedFormField
                form={{ email, getError: () => null }}
                onChange={handleFieldChange}
                type="email"
                id="emailConfirmation"
                field="email"
                label={t('customerdetails.email')}
                required
            />
        </BaseModal>
    );
};

EmailConfirmationModal.propTypes = {
    onConfirm: PropTypes.func.isRequired,
};

export default EmailConfirmationModal;
